import TopicDiscoveryTool from '../../../src/components/content-ai-tools/TopicDiscoveryTool';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={TopicDiscoveryTool} />;
};

export default PublicDiscoveryKeywordsWrapped;
